import { ActionTree } from 'vuex'
import ApolloClient from 'apollo-boost'
import { TechpackState } from './techpack.model'
import getTechpackShare from '@/graphql/queries/getTechpackShare'
import getTechpack from '@/graphql/queries/getTechpack'
import { MutationTypes } from './techpack.mutations'
import techpackDataMapper, { mapTechpackToUITechpackModel } from './mapper'
import {
  GetTechpackShareQuery,
  GetTechpackShareQueryVariables,
  GetFolderTechpackQuery,
  GetFolderTechpackQueryVariables
} from '@/graphql/generated/types'
import { authenticatedApolloClient } from '@/services/authenticated-apollo.service'

export enum ActionTypes {
  GET_TECHPACK = 'GET_TECHPACK',
  GET_TECHPACK_BY_ID = 'GET_TECHPACK_BY_ID'
}

export const actions: ActionTree<TechpackState, unknown> = {
  async [ActionTypes.GET_TECHPACK](
    { commit },
    { apolloClient, techpackId }: { apolloClient: ApolloClient<unknown>; techpackId: string }
  ) {
    commit(MutationTypes.SET_LOADING, true)
    const {
      data: { getTechpackShare: tpShare },
      errors
    } = await apolloClient.query<GetTechpackShareQuery, GetTechpackShareQueryVariables>({
      query: getTechpackShare,
      variables: { techpackId },
      errorPolicy: 'all'
    })
    commit(MutationTypes.SET_LOADING, false)
    if (tpShare) {
      const translatedState = techpackDataMapper(tpShare)
      commit(MutationTypes.SET_TECHPACK_STATE, translatedState)
      if (!translatedState) {
        const errorMessage = `This Tech Pack was deleted. ${tpShare.companyName} will need to share a new link.`
        commit(MutationTypes.SET_ERROR_STATE, errorMessage)
      }
    }
    return { data: tpShare, errors }
  },
  async [ActionTypes.GET_TECHPACK_BY_ID](
    { commit },
    { techpackId, folderId, companyId }: { techpackId: string; folderId: string; companyId: string }
  ) {
    commit(MutationTypes.SET_LOADING, true)

    try {
      const {
        data: { getFolderTechpack: techpack }
      } = await authenticatedApolloClient.query<GetFolderTechpackQuery, GetFolderTechpackQueryVariables>({
        query: getTechpack,
        variables: { id: techpackId, folderId, companyId },
        errorPolicy: 'all'
      })

      if (techpack) {
        const translatedState = mapTechpackToUITechpackModel(techpack)
        commit(MutationTypes.SET_TECHPACK_STATE, translatedState)
      }

      return { data: techpack }
    } catch (err) {
      commit(MutationTypes.SET_ERROR_STATE, err)
    } finally {
      commit(MutationTypes.SET_LOADING, false)
    }
  }
}
